/**
 * Gestionar Familia(REST)
 * Servicios que permite realizar operaciones de gestión sobre las familias.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable, of } from 'rxjs';

import { MSEAsignarMiembroFamilia } from '../../models/api/MSEAsignarMiembroFamilia';
import { MSEBajaMiembroFamilia } from '../../models/api/MSEBajaMiembroFamilia';
import { MSECrearFamilia } from '../../models/api/MSECrearFamilia';
import { MSEFirmarFamilia } from '../../models/api/MSEFirmarFamilia';
import { MSEModificarMiembro } from '../../models/api/MSEModificarMiembro';
import { MSSAsignarMiembroFamilia } from '../../models/api/MSSAsignarMiembroFamilia';
import { MSSBajaMiembroFamilia } from '../../models/api/MSSBajaMiembroFamilia';
import { MSSConsultarInfoCliente } from '../../models/api/MSSConsultarInfoCliente';
import { MSSConsultarMiembrosFamilia } from '../../models/api/MSSConsultarMiembrosFamilia';
import { MSSCrearFamilia } from '../../models/api/MSSCrearFamilia';
import { MSSFirmarFamilia } from '../../models/api/MSSFirmarFamilia';
import { MSSModificarMiembro } from '../../models/api/MSSModificarMiembro';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

// Mocks
import {
  consultarMiembros200,
  consultarMiembrosNoGestor200,
  clienteGestor200,
  clienteNoGestor200,
} from '../mocks/consultarMiembros';

// remove this import (only for DEMO)
import { AuthService } from '../../../../core/auth/auth.service';

@Injectable()
export class GestionarFamiliaSrRestImplService {

  protected basePath = '/MRCConsultaBack_be-web';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration({
    username: 'test',
    password: 'test'
  });

  constructor(private auth: AuthService, protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath + '';
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param - consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * Servicio para asignar un miembro a la familia
   *
   * @param - mseAsignarMiembroFamilia mseAsignarMiembroFamilia
   * @param - observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param - reportProgress flag to report request and response progress.
   */
  public asignarMiembroFamiliaUsingPOST(mseAsignarMiembroFamilia: MSEAsignarMiembroFamilia, observe?: 'body', reportProgress?: boolean): Observable<MSSAsignarMiembroFamilia>;
  public asignarMiembroFamiliaUsingPOST(mseAsignarMiembroFamilia: MSEAsignarMiembroFamilia, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MSSAsignarMiembroFamilia>>;
  public asignarMiembroFamiliaUsingPOST(mseAsignarMiembroFamilia: MSEAsignarMiembroFamilia, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MSSAsignarMiembroFamilia>>;
  public asignarMiembroFamiliaUsingPOST(mseAsignarMiembroFamilia: MSEAsignarMiembroFamilia, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (mseAsignarMiembroFamilia === null || mseAsignarMiembroFamilia === undefined) {
      throw new Error('Required parameter mseAsignarMiembroFamilia was null or undefined when calling asignarMiembroFamiliaUsingPOST.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(`${this.configuration.username}:${this.configuration.password}`));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<MSSAsignarMiembroFamilia>(`${ this.basePath }/api/1.0/clientes/relaciones/familia/nuevo_familiar`,
      mseAsignarMiembroFamilia,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

  /**
   * Servicio para dar de baja el cliente
   *
   * @param - codFamily Código de familia
   * @param - mseBajaMiembroFamilia mseBajaMiembroFamilia
   * @param - observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param - reportProgress flag to report request and response progress.
   */
  public bajaMiembroFamiliaUsingPOST(codFamily: string, mseBajaMiembroFamilia: MSEBajaMiembroFamilia, observe?: 'body', reportProgress?: boolean): Observable<MSSBajaMiembroFamilia>;
  public bajaMiembroFamiliaUsingPOST(codFamily: string, mseBajaMiembroFamilia: MSEBajaMiembroFamilia, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MSSBajaMiembroFamilia>>;
  public bajaMiembroFamiliaUsingPOST(codFamily: string, mseBajaMiembroFamilia: MSEBajaMiembroFamilia, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MSSBajaMiembroFamilia>>;
  public bajaMiembroFamiliaUsingPOST(codFamily: string, mseBajaMiembroFamilia: MSEBajaMiembroFamilia, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (codFamily === null || codFamily === undefined) {
      throw new Error('Required parameter codFamily was null or undefined when calling bajaMiembroFamiliaUsingPOST.');
    }

    if (mseBajaMiembroFamilia === null || mseBajaMiembroFamilia === undefined) {
      throw new Error('Required parameter mseBajaMiembroFamilia was null or undefined when calling bajaMiembroFamiliaUsingPOST.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(`${this.configuration.username}:${this.configuration.password}`));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.delete<MSSBajaMiembroFamilia>(`${ this.basePath }/api/1.0/clientes/relaciones/familia/${ encodeURIComponent(String(codFamily)) }/miembro`,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

  /**
   * Servicio para consultar información de un cliente
   *
   * @param - tipoDocumento Indica el tipo de documento. Posibles valores NIF, NIE.
   * @param - idDocumento Indica el número de documento
   * @param - codACI Indica el código ACI de un cliente. No tiene posibles valores
   * @param - observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param - reportProgress flag to report request and response progress.
   */
  public consultarInfoClienteUsingPOST(tipoDocumento: string, idDocumento: string, codACI?: string, observe?: 'body', reportProgress?: boolean): Observable<MSSConsultarInfoCliente>;
  public consultarInfoClienteUsingPOST(tipoDocumento: string, idDocumento: string, codACI?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MSSConsultarInfoCliente>>;
  public consultarInfoClienteUsingPOST(tipoDocumento: string, idDocumento: string, codACI?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MSSConsultarInfoCliente>>;
  public consultarInfoClienteUsingPOST(tipoDocumento: string, idDocumento: string, codACI?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (tipoDocumento === null || tipoDocumento === undefined) {
      throw new Error('Required parameter tipoDocumento was null or undefined when calling consultarInfoClienteUsingPOST.');
    }

    if (idDocumento === null || idDocumento === undefined) {
      throw new Error('Required parameter idDocumento was null or undefined when calling consultarInfoClienteUsingPOST.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (tipoDocumento !== undefined && tipoDocumento !== null) {
      queryParameters = queryParameters.set('tipoDocumento', tipoDocumento as any);
    }
    if (idDocumento !== undefined && idDocumento !== null) {
      queryParameters = queryParameters.set('idDocumento', idDocumento as any);
    }
    if (codACI !== undefined && codACI !== null) {
      queryParameters = queryParameters.set('codACI', codACI as any);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(`${this.configuration.username}:${this.configuration.password}`));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // remove this block of code
    switch (idDocumento) {
      case '01385631L':
        return of(clienteGestor200);
      case '006234616Y':
        return of(clienteNoGestor200);
      default:
        break;
    }
    // -------------------------------

    return this.httpClient.get<MSSConsultarInfoCliente>(`${ this.basePath }/api/1.0/clientes/relaciones/familia/cliente`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

  /**
   * Servicio para consultar los miembros
   *
   * @param - codFamily Código de familia
   * @param - codClienteRic Código de cliente
   * @param - observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param - reportProgress flag to report request and response progress.
   */
  public consultarMiembrosFamiliaUsingPOST(codFamily: string, codClienteRic: string, observe?: 'body', reportProgress?: boolean): Observable<MSSConsultarMiembrosFamilia>;
  public consultarMiembrosFamiliaUsingPOST(codFamily: string, codClienteRic: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MSSConsultarMiembrosFamilia>>;
  public consultarMiembrosFamiliaUsingPOST(codFamily: string, codClienteRic: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MSSConsultarMiembrosFamilia>>;
  public consultarMiembrosFamiliaUsingPOST(codFamily: string, codClienteRic: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (codFamily === null || codFamily === undefined) {
      throw new Error('Required parameter codFamily was null or undefined when calling consultarMiembrosFamiliaUsingPOST.');
    }

    if (codClienteRic === null || codClienteRic === undefined) {
      throw new Error('Required parameter codClienteRic was null or undefined when calling consultarMiembrosFamiliaUsingPOST.');
    }

    // undo
    const {user} = this.auth.getState();
    if (user.documentNumber === '006234616Y') {
      return of(consultarMiembrosNoGestor200);
    } else {
      return of(consultarMiembros200);
    }
  }

  /**
   * Servicio para crear una familia
   *
   * @param - mseCrearFamilia mseCrearFamilia
   * @param - observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param - reportProgress flag to report request and response progress.
   */
  public crearFamiliaUsingPOST(mseCrearFamilia: MSECrearFamilia, observe?: 'body', reportProgress?: boolean): Observable<MSSCrearFamilia>;
  public crearFamiliaUsingPOST(mseCrearFamilia: MSECrearFamilia, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MSSCrearFamilia>>;
  public crearFamiliaUsingPOST(mseCrearFamilia: MSECrearFamilia, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MSSCrearFamilia>>;
  public crearFamiliaUsingPOST(mseCrearFamilia: MSECrearFamilia, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (mseCrearFamilia === null || mseCrearFamilia === undefined) {
      throw new Error('Required parameter mseCrearFamilia was null or undefined when calling crearFamiliaUsingPOST.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(`${this.configuration.username}:${this.configuration.password}`));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<MSSCrearFamilia>(`${ this.basePath }/api/1.0/clientes/relaciones/familia/nueva_familia`,
      mseCrearFamilia,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

  /**
   * Servicio para firmar una familia con cliente gestor
   *
   * @param - mseFirmarFamilia mseFirmarFamilia
   * @param - observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param - reportProgress flag to report request and response progress.
   */
  public firmarFamiliaUsingPOST(mseFirmarFamilia: MSEFirmarFamilia, observe?: 'body', reportProgress?: boolean): Observable<MSSFirmarFamilia>;
  public firmarFamiliaUsingPOST(mseFirmarFamilia: MSEFirmarFamilia, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MSSFirmarFamilia>>;
  public firmarFamiliaUsingPOST(mseFirmarFamilia: MSEFirmarFamilia, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MSSFirmarFamilia>>;
  public firmarFamiliaUsingPOST(mseFirmarFamilia: MSEFirmarFamilia, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (mseFirmarFamilia === null || mseFirmarFamilia === undefined) {
      throw new Error('Required parameter mseFirmarFamilia was null or undefined when calling firmarFamiliaUsingPOST.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(`${this.configuration.username}:${this.configuration.password}`));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<MSSFirmarFamilia>(`${ this.basePath }/api/1.0/clientes/relaciones/familia/firma_familia`,
      mseFirmarFamilia,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

  /**
   * Servicio para modificar los datos del cliente
   *
   * @param - mseModificarMiembro mseModificarMiembro
   * @param - observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param - reportProgress flag to report request and response progress.
   */
  public modificarMiembroUsingPOST(mseModificarMiembro: MSEModificarMiembro, observe?: 'body', reportProgress?: boolean): Observable<MSSModificarMiembro>;
  public modificarMiembroUsingPOST(mseModificarMiembro: MSEModificarMiembro, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MSSModificarMiembro>>;
  public modificarMiembroUsingPOST(mseModificarMiembro: MSEModificarMiembro, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MSSModificarMiembro>>;
  public modificarMiembroUsingPOST(mseModificarMiembro: MSEModificarMiembro, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (mseModificarMiembro === null || mseModificarMiembro === undefined) {
      throw new Error('Required parameter mseModificarMiembro was null or undefined when calling modificarMiembroUsingPOST.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(`${this.configuration.username}:${this.configuration.password}`));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<MSSModificarMiembro>(`${ this.basePath }/api/1.0/clientes/relaciones/familia/modificacion_miembro`,
      mseModificarMiembro,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

}
